import { createStyles } from './create-styles';
/**
 * Combine multiple styles together
 *
 * @example
 * import { combineStyles } from 'pss'
 *
 * @example
 * import { combineStyles, margin, padding } from 'pss'
 *
 * const space = combineStyles(
 *   margin,
 *   padding
 * )
 *
 * const Space = styled.div`
 *   ${space}
 * `
 *
 * Space.propTypes = {
 *   ...space.propTypes
 * }
 */

export var combineStyles = function combineStyles() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return createStyles(fns.reduce(function (acc, fn) {
    return Object.assign({}, acc, fn.styles);
  }, {}));
};